<template>
	<!-- 烘焙参数 -->
	<v-form>
		<v-card-title class="d-flex align-center flex-wrap">
			<span>{{ readonly ? '烘焙参数' : '修改烘焙参数' }}</span>
			<v-chip v-if="roastOrder.recipe_id" class="ml-2" size="small" color="primary" variant="tonal">
				已关联配方 #{{ roastOrder.recipe_id }}
			</v-chip>
			<v-spacer />
			<v-btn
				v-if="showSaveRecipe && roastOrder.status === 'complete' && form.id"
				size="small"
				variant="tonal"
				@click="saveRecipe"
			>
				保存为新配方
			</v-btn>
		</v-card-title>
		<v-card-text>
			<v-alert v-if="errors.form" type="error" density="compact" class="mb-2">{{ errors.form }}</v-alert>
			<!-- <v-chip class="d-flex d-inline-flex flex-row align-center">
				{{ roastOrder.name }}
			</v-chip> -->
			<v-chip color="primary" class="d-flex d-inline-flex flex-row align-center">
				{{ bean.name }}
			</v-chip>
			<v-chip color="warning" class="d-flex d-inline-flex flex-row align-center">
				<span style="color: green">{{ roastOrder.inqty }}</span>
				=>
				<span style="color: brown; font-weight: bolder">
					{{ roastOrder.outqty }}
				</span>
				克
			</v-chip>
			<v-chip>Agtron: {{ roastOrder.agtron }} / {{ roastOrder.agtron_ground }}</v-chip>

			<recipe-offset-radar
				v-if="recipe && roastOrder.recipe_id"
				:recipe="recipe"
				:roast="roastOrder"
				:profile="form"
			/>

			<div class="d-flex flex-row align-center mt-3">
				入豆温：
				<v-text-field
					type="number"
					hide-details="auto"
					density="compact"
					v-model.number="form.starttemp"
					:error-messages="errors.starttemp"
					style="max-width: 10rem"
				>
					<template #append-inner>
						<iconify-icon icon="mdi:temperature-celsius" style="font-size: 1.2rem" />
					</template>
				</v-text-field>
			</div>
			<div class="d-flex flex-row align-center mt-3">
				回 温：
				<TimeInput v-model="form.tptime" />
				<v-text-field
					class="ml-4"
					type="number"
					density="compact"
					hide-details="auto"
					v-model.number="form.tptemp"
					:error-messages="errors.tptemp"
					style="width: 6rem; max-width: 6rem"
				>
					<template #append-inner>
						<iconify-icon icon="mdi:temperature-celsius" style="font-size: 1.2rem" />
					</template>
				</v-text-field>
			</div>
			<div class="d-flex flex-row align-center mt-3">
				转 黄：
				<TimeInput v-model="form.yellowtime" />
				<v-text-field
					class="ml-4"
					type="number"
					density="compact"
					hide-details="auto"
					v-model.number="form.yellowtemp"
					:error-messages="errors.yellowtemp"
					style="width: 6rem; max-width: 6rem"
				>
					<template #append-inner>
						<iconify-icon icon="mdi:temperature-celsius" style="font-size: 1.2rem" />
					</template>
				</v-text-field>
			</div>
			<div class="d-flex flex-row align-center mt-3">
				一 爆：
				<TimeInput v-model="form.fctime" />
				<v-text-field
					class="ml-4"
					type="number"
					density="compact"
					hide-details="auto"
					v-model.number="form.fctemp"
					:error-messages="errors.fctemp"
					style="width: 6rem; max-width: 6rem"
				>
					<template #append-inner>
						<iconify-icon icon="mdi:temperature-celsius" style="font-size: 1.2rem" />
					</template>
				</v-text-field>
			</div>
			<div class="d-flex flex-row align-center mt-3">
				二 爆：
				<TimeInput v-model="form.sctime" />
				<v-text-field
					class="ml-4"
					type="number"
					density="compact"
					hide-details="auto"
					v-model.number="form.sctemp"
					style="width: 6rem; max-width: 6rem"
				>
					<template #append-inner>
						<iconify-icon icon="mdi:temperature-celsius" style="font-size: 1.2rem" />
					</template>
				</v-text-field>
			</div>
			<div class="d-flex flex-row align-center mt-3">
				总时间：
				<TimeInput v-model="form.totaltime" />
				<template v-if="form.totaltime && form.fctime">
					DTR：
					{{ dtr }}%
				</template>
			</div>
			<v-textarea variant="outlined" v-model="form.memo" label="备注" rows="2" hide-details="auto" class="mt-3" />
			<div class="d-flex flex-row align-center mt-3">
				Agtron:
				<v-text-field label="豆色值agtron" v-model.number="form.agtron" style="max-width: 10rem"></v-text-field>
				<v-text-field
					label="粉色值agtron"
					v-model.number="form.agtron_ground"
					style="max-width: 10rem"
				></v-text-field>
			</div>
		</v-card-text>

		<slot name="actions" :object="form"></slot>
	</v-form>
</template>

<script>
import BeanSelector from '../bean/Selector.vue'
import TimeInput from './TimeInput.vue'
import RecipeOffsetRadar from './RecipeOffsetRadar.vue'

export default {
	components: {
		BeanSelector,
		TimeInput,
		RecipeOffsetRadar
	},
	props: {
		roastId: { type: [Number, String] },
		errors: { type: Object, default: () => ({}) },
		showSaveRecipe: { type: Boolean, default: true },
		readonly: { type: Boolean, default: false }
	},
	data() {
		return {
			form: {
				starttemp: '',
				yellowtemp: '',
				yellowtime: '',
				fctemp: '',
				fctime: '',
				sctemp: '',
				sctime: '',
				totaltime: null
			},
			yellowMin: 0,
			yellowSec: 0,
			fctimeMin: 0,
			fctimeSec: 0,
			sctimeMin: 0,
			sctimeSec: 0,
			profile: {},
			bean: {},
			roastOrder: {},
			recipe: null
		}
	},
	mounted() {
		this.loadProfile()
		this.loadRoast()
	},
	computed: {
		dtr() {
			if (this.form.totaltime && this.form.fctime) {
				let a = ((this.form.totaltime - this.form.fctime) / this.form.totaltime) * 100
				if (a) return a.toFixed(2)
				return 0
			}
		}
	},
	watch: {
		roastId: {
			handler(val) {
				if (val) {
					this.loadProfile()
					this.loadRoast()
				}
			},
			immediate: true
		}
	},
	methods: {
		loadProfile() {
			this.$api.roast.getProfileByRoastId(this.roastId, (res) => {
				this.form = res
				this.loadBean()
				// this.fromYellowTime()
			})
		},
		saveRecipe() {
			if (!this.form.id) {
				alert('请先保存烘焙参数')
				return
			}
			const run = () => {
				this.$api.roast.saveRecipe(
					this.roastId,
					(r) => {
						alert(r.message || `已新建配方 #${r.recipe?.id || ''}`)
						this.loadProfile()
						this.loadRoast()
					},
					(e) => alert(e.message || '保存失败')
				)
			}
			if (this.roastOrder.recipe_id) {
				this.$confirm(
					`已关联配方 #${this.roastOrder.recipe_id}，将新建配方并改关联，不修改原配方。继续？`
				).then((ok) => ok && run())
			} else {
				run()
			}
		},
		// toYellowTime() {
		// 	this.form.yellowtime = this.yellowMin * 60 + this.yellowSec
		// },
		// fromYellowTime() {
		// 	this.yellowMin = Math.floor(this.form.yellowtime / 60)
		// 	this.yellowSec = this.form.yellowtime % 60
		// },
		loadRoast() {
			this.$api.roast.getById(this.roastId, (res) => {
				this.roastOrder = res
				this.recipe = null
				if (res.recipe_id) {
					if (res.recipe && res.recipe.id) {
						this.recipe = res.recipe
					} else {
						this.$api.roast.getRecipeById(res.recipe_id, (r) => {
							this.recipe = r.recipe || r
						})
					}
				}
			})
		},
		loadBean() {
			if (this.form && this.form.bean_id) {
				this.$api.bean.getById(this.form.bean_id, (res) => {
					this.bean = res
				})
			}
		}
	}
}
</script>
